import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useConversationsUnreadCount} from '../../../../../service/hooks/useConversationsUnreadCount';
import Button from '../../../../../incase-domain/components/button/Button';
import Badge from '../../../../../incase-domain/components/badge/Badge';

function MessagesHeaderItem({theme}: {theme: 'light' | 'dark'}): JSX.Element {
    const navigate = useNavigate();
    const {numberOfUnreadMessages} = useConversationsUnreadCount();

    return (
        <Badge value={numberOfUnreadMessages} color="light">
            <Button
                className="c-header__actions_icon"
                color={theme === 'light' ? 'basic' : 'primary'}
                leading="solar:letter-linear"
                size="md"
                variant="ghost"
                square
                onClick={() => navigate('/messages')}
            />
        </Badge>
    );
}

export default MessagesHeaderItem;
